import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import { SVGPrice } from 'constants/SVG';
import { formatCurrency } from 'utils/FormatNumber';

interface Props {
  price: number;
  profit?: number;
}

export const SectionRetailPrice = ({ price, profit }: Props) => {
  if (!price || !profit || price <= 0 || profit <= 0) return <></>;

  return (
    <div className="flex w-fit gap-6 items-center rounded-[30px] bg-[#FDF0DD] h-[25px]">
      <div
        className={clsx(
          'flex gap-2 items-center justify-center px-3',
          'bg-[linear-gradient(90deg,_#FF3D28_0%,_#FF9549_100%)]',
          'rounded-[30px] h-full',
        )}
      >
        <ProfitIcon />
        <span className="text-white text-[14px]">Lợi nhuận bán lẻ</span>
      </div>
      <div className="flex items-center">
        <SVGPrice displayPriceFormated={formatCurrency(profit)} size="sm" />
        <Tooltip
          title={
            <div className="flex flex-col gap-2 p-4">
              <p className="text-[14px] font-[ggsm] text-[#1F1F1F]">Đây là những sản phẩm thuộc nhóm có lợi nhuận cao mà thuocsi gợi ý cho bạn</p>
              <div className="flex justify-between items-center">
                <span className="text-[14px] text-[#1F1F1F] font-[ggsr]">Giá bán lẻ gợi ý</span>
                <SVGPrice displayPriceFormated={formatCurrency(price)} size="sm" />
              </div>
            </div>
          }
          classes={{
            tooltip: clsx('!bg-white p-4 min-w-[384px]', 'shadow-[0px_0px_30px_0px_#0000001F] rounded-[10px]'),
            popper: 'cursor-pointer',
          }}
        >
          <IconButton>
            <InfoOutlinedIcon className="text-[#1D39C4] !h-4 !w-4" />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

const ProfitIcon = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 6C9.63261 6 9.75979 5.94732 9.85355 5.85355C9.94732 5.75979 10 5.63261 10 5.5C10 5.36739 9.94732 5.24021 9.85355 5.14645C9.75979 5.05268 9.63261 5 9.5 5H8.5V4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V7C6 7.26522 6.10536 7.51957 6.29289 7.70711C6.48043 7.89464 6.73478 8 7 8H9V9H6.5C6.36739 9 6.24021 9.05268 6.14645 9.14645C6.05268 9.24021 6 9.36739 6 9.5C6 9.63261 6.05268 9.75979 6.14645 9.85355C6.24021 9.94732 6.36739 10 6.5 10H7.5V10.5C7.5 10.6326 7.55268 10.7598 7.64645 10.8536C7.74021 10.9473 7.86739 11 8 11C8.13261 11 8.25979 10.9473 8.35355 10.8536C8.44732 10.7598 8.5 10.6326 8.5 10.5V10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V8C10 7.73478 9.89464 7.48043 9.70711 7.29289C9.51957 7.10536 9.26522 7 9 7H7V6H9.5Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
      />
      <path
        d="M12.8551 9.64497C12.8086 9.59811 12.7533 9.56091 12.6924 9.53552C12.6314 9.51014 12.5661 9.49707 12.5001 9.49707C12.4341 9.49707 12.3687 9.51014 12.3078 9.53552C12.2469 9.56091 12.1916 9.59811 12.1451 9.64497L10.1451 11.645C10.0757 11.7153 10.0287 11.8046 10.01 11.9016C9.99132 11.9986 10.0018 12.0989 10.0401 12.19C10.0776 12.2813 10.1413 12.3594 10.2231 12.4146C10.305 12.4698 10.4014 12.4995 10.5001 12.5H11.0001V14C11.0001 14.1326 11.0527 14.2598 11.1465 14.3535C11.2403 14.4473 11.3675 14.5 11.5001 14.5C11.6327 14.5 11.7599 14.4473 11.8536 14.3535C11.9474 14.2598 12.0001 14.1326 12.0001 14V12C12.0004 11.8978 11.9694 11.798 11.9113 11.714C11.8532 11.6299 11.7708 11.5657 11.6751 11.53L12.5001 10.705L13.3251 11.53C13.2294 11.5657 13.1469 11.6299 13.0888 11.714C13.0307 11.798 12.9997 11.8978 13.0001 12V14C13.0001 14.1326 13.0527 14.2598 13.1465 14.3535C13.2403 14.4473 13.3675 14.5 13.5001 14.5C13.6327 14.5 13.7599 14.4473 13.8536 14.3535C13.9474 14.2598 14.0001 14.1326 14.0001 14V12.5H14.5001C14.5988 12.4995 14.6951 12.4698 14.777 12.4146C14.8589 12.3594 14.9226 12.2813 14.9601 12.19C14.9984 12.0989 15.0088 11.9986 14.9901 11.9016C14.9714 11.8046 14.9244 11.7153 14.8551 11.645L12.8551 9.64497Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
      />
      <path
        d="M9.385 13.34C8.93097 13.4461 8.46627 13.4998 8 13.5C6.81332 13.5 5.65328 13.1481 4.66658 12.4888C3.67989 11.8295 2.91085 10.8925 2.45673 9.7961C2.0026 8.69975 1.88378 7.49335 2.11529 6.32946C2.3468 5.16558 2.91825 4.09648 3.75736 3.25736C4.59648 2.41825 5.66558 1.8468 6.82946 1.61529C7.99335 1.38378 9.19975 1.5026 10.2961 1.95673C11.3925 2.41085 12.3295 3.17989 12.9888 4.16658C13.6481 5.15328 14 6.31332 14 7.5C14.001 8.04622 13.9253 8.58987 13.775 9.115C13.7529 9.17918 13.7441 9.24719 13.7491 9.31488C13.7542 9.38257 13.7729 9.44853 13.8043 9.50874C13.8356 9.56895 13.8789 9.62214 13.9315 9.66508C13.984 9.70801 14.0448 9.7398 14.1101 9.75849C14.1753 9.77718 14.2437 9.78239 14.311 9.7738C14.3784 9.76521 14.4432 9.743 14.5017 9.70853C14.5602 9.67405 14.611 9.62803 14.6511 9.57327C14.6912 9.51851 14.7198 9.45615 14.735 9.39C14.9108 8.77539 15 8.13926 15 7.5C15 6.11553 14.5895 4.76216 13.8203 3.61101C13.0511 2.45987 11.9579 1.56266 10.6788 1.03285C9.3997 0.503033 7.99224 0.36441 6.63437 0.634506C5.2765 0.904603 4.02922 1.57129 3.05026 2.55026C2.07129 3.52922 1.4046 4.7765 1.13451 6.13437C0.86441 7.49224 1.00303 8.8997 1.53285 10.1788C2.06266 11.4579 2.95987 12.5511 4.11101 13.3203C5.26216 14.0895 6.61553 14.5 8 14.5C8.54393 14.5003 9.08599 14.4365 9.615 14.31C9.73474 14.2714 9.83553 14.1891 9.89729 14.0796C9.95905 13.97 9.97723 13.8411 9.94821 13.7187C9.91918 13.5963 9.84509 13.4894 9.7407 13.4192C9.63632 13.349 9.50931 13.3207 9.385 13.34Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
      />
    </svg>
  );
};

